<template>

    <el-row>
        <el-col :span="18">

            <el-form :model="productForm" :rules="rules"
                     addAction="lcwpgoods/insertNewCar.action" editAction="lcwpgoods/editNewCar.action" label-width="150px"
                     ref="ruleForm" selectAction="lcwpgoods/selectNewCar.action" v-form>

                <el-form-item :rules="[{ required: !productForm.id, message: '车系不能为空'}]" label="选择车系" prop="seriesId"
                              v-if="productForm.type=='新车' || productForm.type=='二手车'">
                    <brand-and-series-categories-select :businessId="productForm.businessId" @onChanged="carCategoryChange"
                                                        brandPlaceholder="品牌（单选）" categoriesPlaceholder="车型"
                                                        ref="brand-and-series-select"
                                                        seriesPlaceholder="车系（单选）" :categoriesMultiple="false"></brand-and-series-categories-select>
                </el-form-item>

                <el-form-item label="最低售价" prop="currentPrice">
                    <el-input placeholder="请填写100-10000000之间的整数（单位元）" type="number"
                              v-model="productForm.currentPrice"></el-input>

                    <p style="color:#666;"><span style="color:red;">提示：最低售价仅作展示使用，不作为最终成交依据！</span></p>
                </el-form-item>

                <el-form-item label="车辆照片" prop="imgLink">
                    <el-upload
                            :before-upload="beforeAvatarUpload"
                            :data="{floder:'plusBusiness'}"
                            :file-list="productForm.imgLink"
                            :http-request="onHttpRequest"
                            :limit="9"
                            accept="image/*"
                            action="upload/uploadPic"
                            list-type="picture-card"
                            multiple
                            ref="imgLink"
                            v-model="productForm.imgLink">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <p style="color:#666;"><span style="color:red;">选择品牌车系后，将自动填充9张新车照片; 自传尺寸：750 * 460像素的，最多9张</span>
                    </p>
                </el-form-item>

                <el-form-item label="车辆描述" prop="goodsDesc">
                    <el-input placeholder="比如：奥迪热销中，目前售价16.88万元起;今日本门店内有现车销售，颜色可选，部分车新可优惠6万元，感兴趣的朋友可以到店咨询购买。" type="textarea"
                              v-model="productForm.goodsDesc"></el-input>
                </el-form-item>

<!--                <el-form-item label="热卖标签" prop="hotLabel">

                    <el-select placeholder="请选择" v-model="productForm.hotLabel">
                        <el-option key="本店热销" label="本店热销" value="本店热销"></el-option>
                        <el-option key="店主推荐" label="店主推荐" value="店主推荐"></el-option>
                        <el-option key="新车到店" label="新车到店" value="新车到店"></el-option>
                        <el-option key="一成首付" label="一成首付" value="一成首付"></el-option>
                        <el-option key="分期免息" label="分期免息" value="分期免息"></el-option>
                        <el-option key="购车大礼包" label="购车大礼包" value="购车大礼包"></el-option>
                    </el-select>

                </el-form-item>-->

                <el-form-item>
                    <el-button type="primary">确定发布</el-button>
                </el-form-item>

            </el-form>

        </el-col>
    </el-row>

</template>

<script>

import ChannelModel from '@/framework/models/channelModel'
import BrandAndSeriesCategoriesSelect from './BrandAndSeriesCategoriesSelect'
import BasicPager from '../../../mixins/BasicPager'
import Config from '@/framework/configs/Config'

export default {
  name: 'add-plus-new-car',
  extends: BasicPager,
  data: function () {
    var checkPrice = (rule, value, callback) => {
      if (value < 100 || value > 10000000) {
        return callback(new Error('请填写100-10000000之间的整数（单位元）'))
      }
      callback()
    }

    return {
      tips: '提示：该类商品只用于发布后展示，暂不支持用户直接线上下单支付',
      placeholder: '比如：埃尔法热销中 目前售价77.2万元起；近日，本店内有埃尔法销售，颜色可选，目前购车部分车型可优惠6.8万元，感兴趣的朋友可以到店咨询购买',
      baseUrl: Config.baseUrl,
      baseImageUrl: Config.imageUrl,
      productForm: {
        type: '新车',
        productInfo: null,
        seriesId: null,
        brandId: null,
        seriesName: null,
        productName: null,
        priceInfo: null,
        imgLink: [],
        businessId: null,
        currentPrice: null,
        factoryName: null
      },
      rules: {
        goodsName: [{
          required: true,
          message: '商品名称不能为空'
        }, {
          type: 'string', required: true, max: 15, message: '最多15个汉字'
        }
        ],
        currentPrice: [{
          required: true,
          message: '最低售价不能为空'
        }, {
          validator: checkPrice, trigger: 'change'
        }],
        imgLink: [
          {
            required: true,
            message: '商品图片不能为空！',
            trigger: 'change'
          }
        ]
      }
    }
  },
  watch: {
    'productForm.productType': function (productType) {
      this.productForm.brandId = null
      this.productForm.seriesId = null
      this.productForm.seriesName = null
      this.productForm.productName = null
      this.productForm.imgLink = []
      this.$refs['brand-and-series-select'].clear()
    }
  },
  components: {
    BrandAndSeriesCategoriesSelect
  },
  created: function () {
    let params = this.$route.params

    this.productForm.id = params.goodsId
    // let businessProductId = parseInt(params.businessProductId)
    // this.productForm.id = businessProductId
    if (params.businessId) {
      let businessId = parseInt(params.businessId)
      this.productForm.businessId = businessId
    }

    if (params.carShowId) {
      this.productForm.carShowId = params.carShowId
    }
  },
  methods: {
    onTypeChange: function () {
      this.productForm.imgLink = []
    },
    carCategoryChange: function (brandInfo, seriesInfo, categoriesInfo) {
      //  String goodsName, String goodsDesc,Integer currentPrice,String officePrice,Integer brandId,Integer seriesId,String categoryIds,
      //                                            String brand,String series,String imgLink,@RequestAttribute Integer businessId
      // 商品名
      this.productForm.goodsName = brandInfo.name + ' ' + seriesInfo.name + ' ' + categoriesInfo.name

      // 官方指定价
      this.productForm.officePrice = categoriesInfo.price

      //
      this.productForm.brandId = brandInfo.id
      this.productForm.brand = brandInfo.name
      this.productForm.seriesId = seriesInfo.id
      this.productForm.series = seriesInfo.name
      this.productForm.factoryName = seriesInfo.factory_name

      this.productForm.categoryIds = categoriesInfo.id

      // 添加照片
      this.productForm.imgLink = []

      let info = seriesInfo.seriesInfo

      let outerImg = info.outerImg.slice(0, 3)
      let centerControlImg = info.centerControl_img.slice(0, 3)
      let seatImg = info.seatImg.slice(0, 3)

      let array = outerImg.concat(centerControlImg, seatImg)

      for (var j = 0; j < array.length; j++) {
        let item = array[j]

        let name = item.replace('https://csz-test.oss-cn-hangzhou.aliyuncs.com/', '').replace('https://csz-public.oss-cn-hangzhou.aliyuncs.com/', '')
        this.productForm.imgLink.push({
          name: name,
          url: item
        })
      }
    },

    beforeAvatarUpload (file) {
      let _this = this
      var promise = new Promise(function (resolve, reject) {
        const isLt5M = file.size / 1024 / 1024 < 5
        if (!isLt5M) {
          _this.$message.error('上传头像图片大小不能超过 5MB!')
          reject(new Error('上传头像图片大小不能超过 5MB!'))
          return
        }

        if (_this.productForm.imgLink.length >= 9) {
          _this.$message.error('最多只能上传9张!')
          reject(new Error('最多只能上传9张!'))
          return
        }
        resolve()
      })
      return promise
    },
    findAllChannels: function (channelName) {
      let _this = this

      let listener = {
        success: function (dataInfo) {
          _this.components[2].prop.options = dataInfo.datas
        }
      }
      ChannelModel.findAllChannels(_this, listener)
    },
    onFilterParams: function (params) {
      params.currentPrice = parseInt(params.currentPrice * 100)
    },
    onSelectInfo: function (dataInfo) {
      this.productForm.currentPrice = Number(dataInfo.datas.currentPrice / 100).valueOf()

      this.$nextTick(function () {
        let brandAndSeriesSelect = this.$refs['brand-and-series-select']
        if (brandAndSeriesSelect) {
          brandAndSeriesSelect.setValue(dataInfo.datas.brandId, dataInfo.datas.seriesId, Number.parseInt(dataInfo.datas.categoryIds))
        }
      })
    }
  }
}

</script>
